export default __webpack_public_path__ + "static/media/ResultSheet.6f2518a0.png";